import React, { ComponentProps } from 'react'
import { SectionList } from 'react-native'

import * as colors from '../../config/colors'
import * as v from '../../config/variables'
import styles from './styles'
import HGListItem from './HGListItem'
import HGText from './HGText'
import HGView from './HGView'

type Props = ComponentProps<typeof SectionList> & {
  sections: Array<any>
  style: any
  link: string
}

const HGSectionList = (props: Props) => {
  const { style, sections } = props

  return (
    <SectionList
      {...props}
      sections={sections}
      renderItem={({ item }) => (
        <HGView>
          <HGListItem item={item} />
        </HGView>
      )}
      renderSectionHeader={(data: any) => (
        <HGView style={{ backgroundColor: colors.beige }}>
          <HGText
            style={[
              styles.groupTitle,
              { marginHorizontal: v.SPACE_SM, marginBottom: v.SPACE_SM },
            ]}
          >
            {data.section.title}
          </HGText>
        </HGView>
      )}
      style={[styles.listStyle, style]}
    />
  )
}

export default HGSectionList
